import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - Componente que rola a página para o topo
 * sempre que a rota muda.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Rola para o topo da página instantaneamente
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
